var _path, _rect, _mask, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgEraserTileBlack = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "-3 -4 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9122 1.4761C20.6498 0.738513 21.8457 0.738512 22.5833 1.4761L32.7051 11.5979C33.4427 12.3355 33.4427 13.5314 32.7051 14.2689L23.2159 23.7581L10.423 10.9653L19.9122 1.4761Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 0.198811
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.09941,
    y: 32.0994,
    width: 26.8012,
    height: 0.801189,
    rx: 0.400594,
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 0.198811
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_5726_8702",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2158 23.8988L10.2824 10.9653L0.582305 20.6654C-0.194101 21.4418 -0.194102 22.7006 0.582304 23.477L8.10529 31H16.1146L23.2158 23.8988Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2824 10.9653L11.6882 9.55952L10.2824 8.15372L8.87657 9.55952L10.2824 10.9653ZM23.2158 23.8988L24.6216 25.3046L26.0274 23.8988L24.6216 22.493L23.2158 23.8988ZM0.582305 20.6654L1.98811 22.0712H1.98811L0.582305 20.6654ZM0.582304 23.477L1.98811 22.0712H1.98811L0.582304 23.477ZM8.10529 31L6.69948 32.4058L7.28179 32.9881H8.10529V31ZM16.1146 31V32.9881H16.9381L17.5204 32.4058L16.1146 31ZM8.87657 12.3711L21.81 25.3046L24.6216 22.493L11.6882 9.55952L8.87657 12.3711ZM1.98811 22.0712L11.6882 12.3711L8.87657 9.55952L-0.823502 19.2596L1.98811 22.0712ZM1.98811 22.0712L1.98811 22.0712L-0.823501 19.2596C-2.37631 20.8124 -2.37632 23.33 -0.823503 24.8828L1.98811 22.0712ZM9.5111 29.5942L1.98811 22.0712L-0.823504 24.8828L6.69948 32.4058L9.5111 29.5942ZM8.10529 32.9881H16.1146V29.0119H8.10529V32.9881ZM21.81 22.493L14.7088 29.5942L17.5204 32.4058L24.6216 25.3046L21.81 22.493Z",
    fill: "#1E1E1E",
    mask: "url(#path-3-inside-1_5726_8702)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEraserTileBlack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/EraserTileBlack.362b33da7a9784462958a5ca37b767ca.svg";